'use client';

import { createContext, useContext } from 'react';

export type ProductDetailContextType = {
    sku: string;
    setSku: (productId: string) => void;
};

const productDetailContextInitialValue: ProductDetailContextType = {
    sku: '',
    setSku: () => console.error('ProductDetailContext: setSku function not implemented'),
};

export const ProductDetailContext = createContext<ProductDetailContextType>(productDetailContextInitialValue);

export const useProductDetailContext = () => useContext(ProductDetailContext);
